import Vue from 'vue';
import Vuex from 'vuex';
import BaseLib from './base/BaseLib';
import bus from './libs/bus';


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    transFilterObj: {
      timeFlag: 0,
      lang: 'zh-CN',

      productid: null,
      productname: null,
      registertime: null,
      authorized: false,
      watchshow: 0,

      platform: [],
      platformFull: [],

      selectedDate: [],
      qualitySelectedDate: [],
      conditions: {
        partner: [],
        usergroup: [],
        version: [],
        newUserGroup: [],
      },
    },
    developerObj: {
      developerid: null,
      email: null,
    },
    productList: [],
    productOwnList: [],
    productObj: {
      authorized: false,
      authorizedpage: '',
      sequencenumber: {},
    },
    storeParam: {
      developerid: null,
      email: null,
    },

    loadingFail: false,
    loadingText: '',
  },
  mutations: {
    setTransFilterObj(state, paramObj) {
      Object.assign(state.transFilterObj, paramObj);
    },
    setLoadingFail(state, paramObj) {
      state.loadingFail = paramObj;
    },
    setLoadingText(state, paramObj) {
      state.loadingText = paramObj;
    },
    sliceProduct(state, id) {
      const index1 = state.productList.findIndex(item => {
        return item.productid === id;
      });
      const index2 = state.productOwnList.findIndex(item => {
        return item.productid === id;
      });
      if (index1 > -1) {
        state.productList.splice(index1, 1);
      }
      if (index2 > -1) {
        state.productOwnList.splice(index2, 1);
      }
    },
    setProductList(state, paramObj) {
      state.productList = BaseLib.cloneDeep(paramObj);
      state.productOwnList = paramObj.filter(item => {
        return !item.authorized;
      });
    },
    setDeveloperObj(state, paramObj) {
      Object.assign(state.developerObj, paramObj);
      state.storeParam.developerid = paramObj.developerid;
      state.storeParam.email = paramObj.email;

      bus.developerid = paramObj.developerid;
      bus.username = paramObj.email;
      bus.userReg = paramObj.registertime;
    },
    setProductObj(state, paramObj) {
      Object.assign(state.productObj, paramObj);
    },
  },
  actions: {
  },
  modules: {
  }
});
